import { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { BusIcon, CargoIcon, SettingIcon } from '../../../src/styles/icons/svg';
import AlertModal from "../../components/form-components/AlertModal";
import LoginForm from "../../components/login/LoginForm.Component";
import '../../styles/login.scss';

const labList = [
    { name: 'Bus', value: 'B', icon: <BusIcon /> },
    { name: 'Cargo', value: 'C', icon: <CargoIcon /> },
    { name: 'Maintenance', value: 'M', icon: <SettingIcon /> },
];

const handlePlatformChange = (value, domaintld) => {
    if (value === 'B') {
        window.location = `https://mavenconnect.${domaintld}/bus`;
    } else if (value === 'C') {
        window.location = `https://mavenconnect.${domaintld}/cargo`;
    } else if (value === 'M') {
    }
};

const MenuTabs = ({ domaintld }) => {
    return (
        <nav className="menu-tabs">
            {labList.map((obj) => (
                <div
                    key={obj.value}
                    className={`tab ${obj.value === 'M' ? "active" : ""}`}
                    onClick={() => handlePlatformChange(obj.value, domaintld)}
                >
                    {obj.icon}
                    <div style={{fontSize:'14px'}}>{obj.name}</div>
                </div>
            ))}
        </nav>
    );
};

export const Entry = () => {
    const [domaintld, setDomaintld] = useState('tech');
    const loginError = useSelector((state) => state.login.loginError);
    const [showAlert, setShowAlert] = useState({ open: false, msg: '' })

    useEffect(() => {
        if (window.location.origin.includes("biz")) {
            setDomaintld("biz");
        }
    }, []);

    useEffect(() => {
        if (loginError && loginError !== '') {
            setShowAlert({ open: true, msg: loginError });
        }
    }, [loginError]);

    return (
        <>
            <div className="login-page">
                <div className="left--part">
                    <div className="login--wrapper">
                        <div className="login-header">
                            <div className="logo-txt">
                                <div className='login--logo--wrapper' key='login-header-logo'><img key='company-logo' src="/images/maventech-logo.png" alt="Maventech Labs Pvt Ltd." /></div>
                                <span className="head--txt">MavenConnect 2.0</span>
                            </div>
                            <MenuTabs domaintld={domaintld} />
                        </div>
                        <LoginForm />

                    </div>
                    <div className="bottom-section">
                        <div className="link-text" style={{fontSize:'14px'}}>
                                <a href="https://cargoapi.mavenconnect.tech/CargoLauncher/Live/setup.exe" target="_blank" rel="noreferrer">Download Security Environment Enabler (SEE)</a>
                        </div>
                        <div className="bottom-text">
                            You agree to our <a href="http://buscrs.com/terms_of_use" target="_blank" rel="noreferrer">Terms of Use</a> agreement and <a target="_blank" rel="noreferrer" href="http://buscrs.com/privacy_policy">Privacy Policy</a>
                        </div>
                        <div className="helpline--wrapper"  >
                            MavenTech Labs Helpline 08065927752 (10:30 AM to 08:30 PM)
                        </div>
                        <div className="copy--right--txt"> &copy; {new Date().getFullYear()} Operated by Maventech Labs Private Limited.</div>
                    </div>
                </div>
                <div className='footer-image--wrapper'>
                    <img key='footer-image' src="/images/footerImage.png" alt="Maventech Labs Pvt Ltd." />
                </div>
            </div>
            {showAlert?.open && <AlertModal msg={showAlert?.msg} onClose={() => {
                setShowAlert({ open: false, msg: '' })
            }} />}
        </>
    );
};